import { render, staticRenderFns } from "./SingleRegistration.vue?vue&type=template&id=0eb78310&"
import script from "./SingleRegistration.ts?vue&type=script&lang=ts&"
export * from "./SingleRegistration.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports